// extracted by mini-css-extract-plugin
module.exports = {"t2_div":"t2Breadcrumb_t2_div__fUqd8","list_group":"t2Breadcrumb_list_group__gfFtX","list_group_item":"t2Breadcrumb_list_group_item__1Ie5w"};